"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetProductById = void 0;

var _products = require("./products.reducer");

var getProductsState = function getProductsState(state) {
  return state.modules.marketplace.products;
};

var _productsAdapter$getS = _products.productsAdapter.getSelectors(getProductsState),
    getById = _productsAdapter$getS.getById;

var makeGetProductById = function makeGetProductById(id, denomination) {
  return getById((0, _products.createProductId)({
    id,
    denomination: denomination ? {
      price: denomination
    } : undefined
  }));
};

exports.makeGetProductById = makeGetProductById;